import type { InteractionTokenResponse } from '~/types/api';
import type { InteractionTokenPayload } from '~/types/interaction';
import httpRequest from '~/utils/httpRequest';

export const getInteractionToken = async (
    payload: InteractionTokenPayload,
): Promise<InteractionTokenResponse> => {
    const res = await httpRequest.post<InteractionTokenResponse>(
        'api/createInteraction',
        payload,
    );
    return res.data;
};
